import { dataTextShengSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTextShengSquareSolid = /*#__PURE__*/createIcon(dataTextShengSquareSolid)
export default IconTextShengSquareSolid
